import Facebook from "./Facebook";
import Telegram from "./Telegram";
import Whatsapp from "./Whatsapp";
import Twitter from "./Twitter";
import Viber from "./Viber";

export default function Icon({ svg, ...props }) {
  switch (svg) {
    case "facebook":
      return <Facebook {...props} />;
    case "twitter":
      return <Twitter {...props} />;
    case "whatsapp":
      return <Whatsapp {...props} />;
    case "telegram":
      return <Telegram {...props} />;
    case "viber":
      return <Viber {...props} />;
    default:
      return null;
  }
}
